module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00316.f685f740.jpg";